<div
  class="tw:flex tw:flex-col tw:gap-2.5 tw:bg-white tw:relative tw:max-w-120 tw:!rounded-none content-wrapper tw:w-full tw:shadow-lg"
  [rounded]="false"
  cfDialogContent
>
  <button cfDialogDismiss class="tw:absolute tw:top-4 tw:left-4">
    <svg class="tw:cursor-pointer tw:text-grey-70" cfIcon="close"></svg>
  </button>
  <div class="tw:flex tw:flex-col tw:gap-6">
    <div class="tw:flex tw:flex-col tw:gap-2">
      <div class="tw:text-gray-80 tw:text-2xl tw:font-semibold">{{ "icloud-hint.title" | translate }}</div>
      <div class="tw:text-gray-70 tw:text-base tw:leading-normal">
        {{ "icloud-hint.description" | translate }}
      </div>
    </div>
    <div class="tw:flex tw:flex-col tw:gap-2">
      <div class="tw:text-gray-80 tw:text-2xl tw:font-semibold">{{ "icloud-hint.app-password.title" | translate }}</div>
      <div class="tw:text-gray-70 tw:text-base tw:leading-normal">
        {{ "icloud-hint.app-password.description" | translate }}
      </div>
    </div>
    <div class="tw:text-gray-70 tw:text-base tw:font-semibold tw:leading-normal">
      {{ "icloud-hint.steps.title" | translate }}
    </div>
    <div class="tw:flex tw:flex-col tw:gap-6">
      <div class="tw:flex tw:flex-col tw:gap-2">
        <div>
          <span class="tw:text-gray-70 tw:text-base tw:leading-normal">{{
            "icloud-hint.steps.step1.prefix" | translate
          }}</span>
          <a
            class="tw:text-blue-50 tw:text-base tw:font-medium tw:leading-normal"
            href="https://appleid.apple.com/"
            target="_blank"
            cfButton
            variant="link"
            rel="nofollow"
            >{{ "icloud-hint.steps.step1.link" | translate }}</a
          >
        </div>
        <div class="tw:text-gray-70 tw:text-base tw:leading-normal">
          {{ "icloud-hint.steps.step2" | translate }}
        </div>
        <img class="tw:rounded-lg" src="/assets/icloud/hint-1.jpg" />
      </div>
      <div class="tw:flex tw:flex-col tw:gap-2">
        <div class="tw:text-gray-70 tw:text-base tw:leading-normal">
          {{ "icloud-hint.steps.step3" | translate }}
        </div>
        <img class="tw:rounded-lg" src="/assets/icloud/hint-2.jpg" />
      </div>
      <div class="tw:flex tw:flex-col tw:gap-2">
        <div class="tw:text-gray-70 tw:text-base tw:leading-normal">{{ "icloud-hint.steps.step4" | translate }}</div>
        <img class="tw:rounded-lg" src="/assets/icloud/hint-3.jpg" />
      </div>
    </div>
    <div class="tw:flex tw:flex-col tw:gap-2">
      <div class="tw:text-gray-80 tw:text-2xl tw:font-semibold">{{ "icloud-hint.add-calendar.title" | translate }}</div>
      <div class="tw:text-gray-70 tw:text-base tw:leading-normal">
        {{ "icloud-hint.add-calendar.description" | translate }}
      </div>
    </div>
    <img class="tw:rounded-lg" src="/assets/icloud/hint-4.jpg" />
  </div>
  <div class="tw:text-gray-70 tw:text-base tw:leading-normal">
    {{ "icloud-hint.credentials.description" | translate }}
  </div>
  <div class="tw:text-gray-70 tw:text-base tw:leading-normal" [class.tw:pb-120]="isIosMobile()">
    {{ "icloud-hint.success.description" | translate }}
  </div>
</div>
